import { useCallback, useState } from "react";
import {
  functionalUpdate,
  OnChangeFn,
  SortingState,
} from "@tanstack/react-table";

import { ORDER } from "~/common/constants";
import {
  getOrderByFromColumnId,
  SESSIONS_TABLE_COLUMN_IDS,
} from "./sessionsTableSorting";

const DEFAULT_SORTING: SortingState = [
  { id: SESSIONS_TABLE_COLUMN_IDS.date, desc: true },
];

export const useSessionsTableSorting = () => {
  const [sorting, setSorting] = useState<SortingState>(DEFAULT_SORTING);

  const onSortingChange: OnChangeFn<SortingState> = useCallback((updater) => {
    setSorting((current) => functionalUpdate(updater, current));
  }, []);

  const orderBy =
    getOrderByFromColumnId(sorting[0]?.id ?? SESSIONS_TABLE_COLUMN_IDS.date) ??
    "scheduled_start_time";
  const order = sorting[0]?.desc === false ? ORDER.ascendant : ORDER.descendant;

  return { sorting, onSortingChange, orderBy, order };
};
